<template>
  <el-dialog :title="required ? '首次登录，请修改密码' : '修改密码'" :visible="visible" width="460px"
    :close-on-click-modal="false" :close-on-press-escape="!required && !saving" :show-close="!required && !saving" @close="close">
    <p class="password-tip">{{ required ? '首次登录 PC 系统需修改密码，完成后请重新登录。' : '修改成功后原有登录会话失效，请使用新密码重新登录。' }}</p>
    <el-form ref="form" :model="form" :rules="rules" label-width="90px" autocomplete="off" @submit.native.prevent @keyup.enter.native="submit">
      <el-form-item label="原密码" prop="old_password"><el-input v-model="form.old_password" type="password" show-password autocomplete="new-password" placeholder="请输入原密码" /></el-form-item>
      <el-form-item label="新密码" prop="new_password"><el-input v-model="form.new_password" type="password" show-password autocomplete="new-password" :maxlength="64" placeholder="请输入 8 至 64 位新密码" /></el-form-item>
      <el-form-item label="确认密码" prop="confirm_password"><el-input v-model="form.confirm_password" type="password" show-password autocomplete="new-password" :maxlength="64" placeholder="请再次输入新密码" /></el-form-item>
    </el-form>
    <span slot="footer">
      <el-button :disabled="saving" @click="required ? logout() : close()">{{ required ? '退出登录' : '取消' }}</el-button>
      <el-button type="primary" :loading="saving" @click="submit">确认修改</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { authApi } from '../services/api'
const emptyForm = () => ({ old_password: '', new_password: '', confirm_password: '' })
export default {
  data () {
    const confirm = (rule, value, callback) => callback(value !== this.form.new_password ? new Error('两次输入的新密码不一致') : undefined)
    return {
      opened: false, saving: false, form: emptyForm(),
      rules: {
        old_password: [{ required: true, message: '请输入原密码', trigger: 'blur' }],
        new_password: [{ required: true, message: '请输入新密码', trigger: 'blur' }, { min: 8, max: 64, message: '新密码长度须为 8 至 64 位', trigger: 'blur' }],
        confirm_password: [{ required: true, message: '请再次输入新密码', trigger: 'blur' }, { validator: confirm, trigger: 'blur' }]
      }
    }
  },
  computed: {
    required () { return Boolean(this.$store.state.token && this.$store.state.user && this.$store.state.user.password_change_required) },
    visible () { return Boolean(this.$store.state.token && (this.required || this.opened)) }
  },
  watch: { visible (value) { if (!value) { this.opened = false; this.reset() } } },
  mounted () { this.$root.$on('password-change:open', this.open) },
  beforeDestroy () { this.$root.$off('password-change:open', this.open) },
  methods: {
    reset () { this.form = emptyForm(); this.$nextTick(() => { if (this.$refs.form) this.$refs.form.clearValidate() }) },
    open () { this.reset(); this.opened = true },
    close () { if (!this.required && !this.saving) { this.opened = false; this.reset() } },
    async logout () {
      try { await this.$store.dispatch('logout') } catch (e) { if (!e.authExpired) this.$message.error(e.message) }
      this.opened = false
      if (this.$route.path !== '/login') this.$router.replace('/login')
    },
    submit () {
      if (this.saving) return
      this.$refs.form.validate(async valid => {
        if (!valid || this.saving) return
        if (this.form.new_password === this.form.old_password) return this.$message.error('新密码不能与原密码相同')
        this.saving = true
        try {
          await authApi.changePassword(this.form)
          this.opened = false
          this.$store.commit('session', null)
          this.reset()
          this.$message.success('密码修改成功，请使用新密码重新登录')
          if (this.$route.path !== '/login') this.$router.replace('/login')
        } catch (e) { if (!e.authExpired) this.$message.error(e.message) } finally { this.saving = false }
      })
    }
  }
}
</script>
<style scoped>.password-tip{margin:0 0 24px;color:#718796;line-height:1.7}</style>
